// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * User Detail Modal Styles
 * Professional styling with proper alignment and green theme
 */

/* ============================================
   USER DETAIL MODAL MAIN STYLES
   ============================================ */

.user-detail-modal {
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.user-detail-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px;
  background: #FFFFFF;
}

.user-detail-body::-webkit-scrollbar {
  width: 8px;
}

.user-detail-body::-webkit-scrollbar-track {
  background: #f1ede2;
}

.user-detail-body::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 4px;
}

.user-detail-body::-webkit-scrollbar-thumb:hover {
  background: #8792a6;
}

/* ============================================
   MODAL HEADER
   ============================================ */

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  padding: 28px 32px;
  border-bottom: 2px solid #e3ddcd;
  background: linear-gradient(135deg, #f1ede2 0%, #f1ede2 100%);
}

.modal-header h2 {
  margin: 0;
  padding: 0;
}

.modal-title {
  font-size: 22px;
  font-weight: 800;
  color: #0a1628;
  letter-spacing: -0.5px;
}

.modal-subtitle {
  font-size: 12px;
  color: #8792a6;
  margin: 4px 0 0 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-close {
  background: white;
  border: 1px solid #e3ddcd;
  font-size: 24px;
  cursor: pointer;
  color: #8792a6;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 250ms;
  flex-shrink: 0;
}

.modal-close:hover {
  background: #f1ede2;
  border-color: #101f38;
  color: #101f38;
}

/* ============================================
   DETAIL SECTIONS
   ============================================ */

.detail-section {
  margin-bottom: 32px;
  padding: 24px;
  background: #FFFFFF;
  border: 1.5px solid #e3ddcd;
  border-radius: 12px;
  transition: all 250ms;
}

.detail-section:hover {
  border-color: #101f38;
  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.08);
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #0a1628;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e3ddcd;
  letter-spacing: -0.3px;
}

.section-icon {
  font-size: 18px;
  display: inline-block;
}

/* ============================================
   PROFILE SECTION
   ============================================ */

.profile-section {
  text-align: center;
  background: linear-gradient(135deg, #f1ede2 0%, rgba(16, 31, 56, 0.03) 100%);
}

.profile-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-image {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  object-fit: cover;
  border: 3px solid #101f38;
  cursor: pointer;
  transition: all 250ms;
  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.2);
}

.profile-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(16, 31, 56, 0.3);
}

/* ============================================
   INFO GRID & ITEMS
   ============================================ */

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  font-weight: 700;
  color: #101f38;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #0a1628;
  margin: 0;
  line-height: 1.5;
  padding: 8px 12px;
  background: #f1ede2;
  border-radius: 8px;
  border-left: 3px solid #101f38;
}

/* ============================================
   DESCRIPTION TEXT
   ============================================ */

.description-text {
  font-size: 14px;
  line-height: 1.8;
  color: #48546b;
  margin: 0;
  padding: 16px;
  background: #f1ede2;
  border-radius: 8px;
  border-left: 3px solid #101f38;
}

/* ============================================
   IMAGES GALLERY
   ============================================ */

.images-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.image-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f1ede2;
  border-radius: 12px;
  border: 2px solid #e3ddcd;
  transition: all 250ms;
}

.image-card:hover {
  border-color: #101f38;
  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.1);
}

.image-label {
  font-size: 12px;
  font-weight: 700;
  color: #101f38;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.gallery-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: all 250ms;
  border: 2px solid #e3ddcd;
}

.gallery-image:hover {
  border-color: #101f38;
  transform: scale(1.02);
}

.expand-btn {
  padding: 8px 12px;
  background: linear-gradient(135deg, #101f38, #2f6f5e);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 250ms;
  letter-spacing: 0.3px;
}

.expand-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.3);
}

.expand-btn:active {
  transform: translateY(0);
}

/* ============================================
   IMAGE EXPANSION MODAL
   ============================================ */

.image-expand-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: fadeIn 250ms;
  backdrop-filter: blur(4px);
}

.image-expand-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expanded-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  animation: slideUp 300ms;
}

.image-expand-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 44px;
  height: 44px;
  background: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0a1628;
  transition: all 250ms;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-expand-close:hover {
  transform: scale(1.1) rotate(90deg);
  background: #101f38;
  color: white;
}

/* ============================================
   STATUS INFO
   ============================================ */

.status-info {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}

.status-badge {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.status-badge[data-status="pending"] {
  background: #f6ecd9;
  color: #7a5220;
}

.status-badge[data-status="approved"] {
  background: #e3efe9;
  color: #245349;
}

.status-badge[data-status="rejected"] {
  background: #fbeae5;
  color: #8a3322;
}

/* ============================================
   REJECTION SECTION
   ============================================ */

.rejection-section {
  background: linear-gradient(135deg, #fbeae5 0%, rgba(201, 86, 58, 0.03) 100%);
  border-color: #fbeae5;
}

.rejection-title {
  color: #b3432b;
  border-bottom-color: #fbeae5;
}

.rejection-textarea {
  width: 100%;
  padding: 14px;
  border: 2px solid #fbeae5;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #0a1628;
  background: white;
  resize: vertical;
  min-height: 120px;
  transition: all 250ms;
}

.rejection-textarea:focus {
  outline: none;
  border-color: #b3432b;
  box-shadow: 0 0 0 3px rgba(201, 86, 58, 0.1);
}

.rejection-textarea:disabled {
  background: #fbeae5;
  opacity: 0.6;
}

/* ============================================
   MODAL FOOTER
   ============================================ */

.user-detail-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 32px;
  border-top: 2px solid #e3ddcd;
  background: #f1ede2;
  flex-wrap: wrap;
}

/* ============================================
   ANIMATIONS
   ============================================ */

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

@media (max-width: 768px) {
  .user-detail-modal {
    max-width: 95vw;
  }

  .modal-header {
    padding: 20px;
    gap: 12px;
    flex-direction: column;
  }

  .modal-close {
    align-self: flex-end;
  }

  .user-detail-body {
    padding: 20px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .images-gallery {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }

  .detail-section {
    padding: 16px;
    margin-bottom: 20px;
  }

  .user-detail-footer {
    padding: 16px;
    gap: 8px;
  }

  .image-expand-close {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .user-detail-modal {
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 12px 12px 0 0;
  }

  .modal-header {
    padding: 16px;
  }

  .modal-title {
    font-size: 18px;
  }

  .modal-subtitle {
    display: none;
  }

  .user-detail-body {
    padding: 16px;
  }

  .detail-section {
    padding: 12px;
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .info-label {
    font-size: 11px;
  }

  .info-value {
    font-size: 13px;
  }

  .images-gallery {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .gallery-image {
    height: 120px;
  }

  .expand-btn {
    padding: 6px 10px;
    font-size: 11px;
  }

  .user-detail-footer {
    padding: 12px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
    font-size: 13px;
  }

  .image-expand-overlay {
    z-index: 5000;
  }

  .expanded-image {
    border-radius: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/UserDetailModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,6EAA6E;EAC7E,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/**\n * User Detail Modal Styles\n * Professional styling with proper alignment and green theme\n */\n\n/* ============================================\n   USER DETAIL MODAL MAIN STYLES\n   ============================================ */\n\n.user-detail-modal {\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-detail-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px;\n  background: #FFFFFF;\n}\n\n.user-detail-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.user-detail-body::-webkit-scrollbar-track {\n  background: #f1ede2;\n}\n\n.user-detail-body::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 4px;\n}\n\n.user-detail-body::-webkit-scrollbar-thumb:hover {\n  background: #8792a6;\n}\n\n/* ============================================\n   MODAL HEADER\n   ============================================ */\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n  padding: 28px 32px;\n  border-bottom: 2px solid #e3ddcd;\n  background: linear-gradient(135deg, #f1ede2 0%, #f1ede2 100%);\n}\n\n.modal-header h2 {\n  margin: 0;\n  padding: 0;\n}\n\n.modal-title {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0a1628;\n  letter-spacing: -0.5px;\n}\n\n.modal-subtitle {\n  font-size: 12px;\n  color: #8792a6;\n  margin: 4px 0 0 0;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.modal-close {\n  background: white;\n  border: 1px solid #e3ddcd;\n  font-size: 24px;\n  cursor: pointer;\n  color: #8792a6;\n  padding: 6px 10px;\n  border-radius: 8px;\n  transition: all 250ms;\n  flex-shrink: 0;\n}\n\n.modal-close:hover {\n  background: #f1ede2;\n  border-color: #101f38;\n  color: #101f38;\n}\n\n/* ============================================\n   DETAIL SECTIONS\n   ============================================ */\n\n.detail-section {\n  margin-bottom: 32px;\n  padding: 24px;\n  background: #FFFFFF;\n  border: 1.5px solid #e3ddcd;\n  border-radius: 12px;\n  transition: all 250ms;\n}\n\n.detail-section:hover {\n  border-color: #101f38;\n  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.08);\n}\n\n.section-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0a1628;\n  margin: 0 0 20px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e3ddcd;\n  letter-spacing: -0.3px;\n}\n\n.section-icon {\n  font-size: 18px;\n  display: inline-block;\n}\n\n/* ============================================\n   PROFILE SECTION\n   ============================================ */\n\n.profile-section {\n  text-align: center;\n  background: linear-gradient(135deg, #f1ede2 0%, rgba(16, 31, 56, 0.03) 100%);\n}\n\n.profile-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.profile-image {\n  width: 120px;\n  height: 120px;\n  border-radius: 12px;\n  object-fit: cover;\n  border: 3px solid #101f38;\n  cursor: pointer;\n  transition: all 250ms;\n  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.2);\n}\n\n.profile-image:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 20px rgba(16, 31, 56, 0.3);\n}\n\n/* ============================================\n   INFO GRID & ITEMS\n   ============================================ */\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #101f38;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0a1628;\n  margin: 0;\n  line-height: 1.5;\n  padding: 8px 12px;\n  background: #f1ede2;\n  border-radius: 8px;\n  border-left: 3px solid #101f38;\n}\n\n/* ============================================\n   DESCRIPTION TEXT\n   ============================================ */\n\n.description-text {\n  font-size: 14px;\n  line-height: 1.8;\n  color: #48546b;\n  margin: 0;\n  padding: 16px;\n  background: #f1ede2;\n  border-radius: 8px;\n  border-left: 3px solid #101f38;\n}\n\n/* ============================================\n   IMAGES GALLERY\n   ============================================ */\n\n.images-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-top: 16px;\n}\n\n.image-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: #f1ede2;\n  border-radius: 12px;\n  border: 2px solid #e3ddcd;\n  transition: all 250ms;\n}\n\n.image-card:hover {\n  border-color: #101f38;\n  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.1);\n}\n\n.image-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #101f38;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.gallery-image {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 250ms;\n  border: 2px solid #e3ddcd;\n}\n\n.gallery-image:hover {\n  border-color: #101f38;\n  transform: scale(1.02);\n}\n\n.expand-btn {\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #101f38, #2f6f5e);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 250ms;\n  letter-spacing: 0.3px;\n}\n\n.expand-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(16, 31, 56, 0.3);\n}\n\n.expand-btn:active {\n  transform: translateY(0);\n}\n\n/* ============================================\n   IMAGE EXPANSION MODAL\n   ============================================ */\n\n.image-expand-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  animation: fadeIn 250ms;\n  backdrop-filter: blur(4px);\n}\n\n.image-expand-container {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.expanded-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 12px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n  animation: slideUp 300ms;\n}\n\n.image-expand-close {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  width: 44px;\n  height: 44px;\n  background: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0a1628;\n  transition: all 250ms;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.image-expand-close:hover {\n  transform: scale(1.1) rotate(90deg);\n  background: #101f38;\n  color: white;\n}\n\n/* ============================================\n   STATUS INFO\n   ============================================ */\n\n.status-info {\n  display: flex;\n  justify-content: center;\n  margin: 24px 0;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.status-badge[data-status=\"pending\"] {\n  background: #f6ecd9;\n  color: #7a5220;\n}\n\n.status-badge[data-status=\"approved\"] {\n  background: #e3efe9;\n  color: #245349;\n}\n\n.status-badge[data-status=\"rejected\"] {\n  background: #fbeae5;\n  color: #8a3322;\n}\n\n/* ============================================\n   REJECTION SECTION\n   ============================================ */\n\n.rejection-section {\n  background: linear-gradient(135deg, #fbeae5 0%, rgba(201, 86, 58, 0.03) 100%);\n  border-color: #fbeae5;\n}\n\n.rejection-title {\n  color: #b3432b;\n  border-bottom-color: #fbeae5;\n}\n\n.rejection-textarea {\n  width: 100%;\n  padding: 14px;\n  border: 2px solid #fbeae5;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #0a1628;\n  background: white;\n  resize: vertical;\n  min-height: 120px;\n  transition: all 250ms;\n}\n\n.rejection-textarea:focus {\n  outline: none;\n  border-color: #b3432b;\n  box-shadow: 0 0 0 3px rgba(201, 86, 58, 0.1);\n}\n\n.rejection-textarea:disabled {\n  background: #fbeae5;\n  opacity: 0.6;\n}\n\n/* ============================================\n   MODAL FOOTER\n   ============================================ */\n\n.user-detail-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 20px 32px;\n  border-top: 2px solid #e3ddcd;\n  background: #f1ede2;\n  flex-wrap: wrap;\n}\n\n/* ============================================\n   ANIMATIONS\n   ============================================ */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n\n@media (max-width: 768px) {\n  .user-detail-modal {\n    max-width: 95vw;\n  }\n\n  .modal-header {\n    padding: 20px;\n    gap: 12px;\n    flex-direction: column;\n  }\n\n  .modal-close {\n    align-self: flex-end;\n  }\n\n  .user-detail-body {\n    padding: 20px;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .images-gallery {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 12px;\n  }\n\n  .detail-section {\n    padding: 16px;\n    margin-bottom: 20px;\n  }\n\n  .user-detail-footer {\n    padding: 16px;\n    gap: 8px;\n  }\n\n  .image-expand-close {\n    top: 10px;\n    right: 10px;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .user-detail-modal {\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 12px 12px 0 0;\n  }\n\n  .modal-header {\n    padding: 16px;\n  }\n\n  .modal-title {\n    font-size: 18px;\n  }\n\n  .modal-subtitle {\n    display: none;\n  }\n\n  .user-detail-body {\n    padding: 16px;\n  }\n\n  .detail-section {\n    padding: 12px;\n    margin-bottom: 16px;\n  }\n\n  .section-title {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .info-label {\n    font-size: 11px;\n  }\n\n  .info-value {\n    font-size: 13px;\n  }\n\n  .images-gallery {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 8px;\n  }\n\n  .gallery-image {\n    height: 120px;\n  }\n\n  .expand-btn {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  .user-detail-footer {\n    padding: 12px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    font-size: 13px;\n  }\n\n  .image-expand-overlay {\n    z-index: 5000;\n  }\n\n  .expanded-image {\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
